import registerNav from "./nav.js";
import registerFaqs from "./faqs.js";
import registerYoutubeModal from "./youtube-modal";
import registerResponsiveVideo from "./responsive-video";
import registerTextAnimations from "./text-animations";

registerNav();
registerFaqs();
registerYoutubeModal();
registerResponsiveVideo();
registerTextAnimations();
